export const SERVICES = [
  { id: 'emprestimo', label: 'Empréstimo' },
  { id: 'conta-baas', label: 'Conta BaaS (Para Out da sua operação)' },
  { id: 'apis-cartao-pix-boleto', label: 'APIs de Cartão, Pix e Boleto' },
  { id: 'api-pix-nominal', label: 'API Pix Nominal' },
  { id: 'api-pix-igaming', label: 'API Pix iGaming' },
  { id: 'maquininhas', label: 'Maquininhas de cartão' },
  { id: 'link-pagamentos', label: 'Link de pagamentos' }
]

export const REVENUE_OPTIONS = [
  'entre 0k e 10k',
  'entre 10k e 50k',
  'entre 50k e 100k',
  'entre 100k e 500k',
  'entre 500k e 1m',
  'acima de 1m'
]

export const REVENUE_API_MAP = {
  'entre 0k e 10k': '0ka10k',
  'entre 10k e 50k': '10ka50k',
  'entre 50k e 100k': '50ka100k',
  'entre 100k e 500k': '100ka500k',
  'entre 500k e 1m': '500ka1m',
  'acima de 1m': 'acima1m'
}

export const BRAND_SOLUTIONS = [
  'Conta BaaS (Para Out da sua operação)',
  'APIs de Cartão, Pix e Boleto',
  'API Pix Nominal',
  'API Pix iGaming',
  'Maquininhas de cartão',
  'Link de pagamentos'
]

export function getServiceLabel(serviceId) {
  return SERVICES.find((s) => s.id === serviceId)?.label || serviceId
}
